import { Link } from 'react-router-dom';
import { popularContent } from '@/mocks/home';

export default function PopularContent() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-2">
              热门内容
            </h2>
            <p className="text-sm text-foreground-500">大家都在看的精彩视频</p>
          </div>
          <Link
            to="/category/搞笑"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop>
          {popularContent.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group block"
            >
              <div className="relative rounded-xl overflow-hidden aspect-[3/4] mb-3">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-1.5 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full">
                    {item.category}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors mb-1.5">
                {item.title}
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i> {item.views}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-heart-line"></i> {item.likes}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}